import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Box, Typography, Card, CardContent } from '@mui/material';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CampaignPerformanceChart = ({ data, title = "Performance Financeira de Campanhas" }) => {
  // Ordenar por receita total (descendente)
  const sortedData = [...data]
    .sort((a, b) => parseFloat(b.total_revenue) - parseFloat(a.total_revenue))
    .slice(0, 15); // Top 15 campanhas

  const chartData = {
    labels: sortedData.map(item => {
      const source = item.utm_source || 'Direto';
      const campaign = item.utm_campaign || '';
      return campaign ? `${source} - ${campaign}` : source;
    }),
    datasets: [
      {
        label: 'Receita Total (R$)',
        data: sortedData.map(item => parseFloat(item.total_revenue)),
        backgroundColor: 'rgba(78, 205, 196, 0.8)',
        borderColor: 'rgba(78, 205, 196, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: 'y', // Gráfico horizontal
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.parsed?.x || 0;
            return `Receita: R$ ${value.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`;
          },
          afterLabel: function(context) {
            try {
              const item = sortedData[context.dataIndex];
              if (item) {
                return [
                  `Vendas: ${item.total_sales?.toLocaleString('pt-BR') || 0}`,
                  `Ticket Médio: R$ ${parseFloat(item.average_ticket || 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}`
                ];
              }
              return [];
            } catch (e) {
              return [];
            }
          },
        },
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Receita Total (R$)',
        },
        ticks: {
          callback: function(value) {
            return `R$ ${value.toLocaleString('pt-BR')}`;
          },
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Campanhas',
        },
        ticks: {
          maxRotation: 0,
          callback: function(value, index) {
            const label = this.getLabelForValue(value);
            return label.length > 30 ? label.substring(0, 30) + '...' : label;
          },
        },
      },
    },
  };

  if (!data || data.length === 0) {
    return (
      <Card sx={{ height: 500 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          <Box display="flex" alignItems="center" justifyContent="center" height={400}>
            <Typography color="text.secondary">
              Não há dados disponíveis para exibir
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: 500 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Box height={420}>
          <Bar data={chartData} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default CampaignPerformanceChart;
